import {z} from 'zod'

import {BlockHighlightVisualizationEnum} from '@sdox/api'

import {i18nValidation} from '../../../../../'
import {buttonSchema} from './buttonSchemas'

const baseHighlightSchema = z.object({
  cta: buttonSchema,
  image: z.object({
    fileHash: z.string().min(1),
  }),
  imageMobile: z.object({
    fileHash: z.string().min(1),
  }).nullish(),
})

const defaultHighlightSchema = baseHighlightSchema.extend({
  title: z.string().min(1, {message: i18nValidation.enterText}),
  description: z.string().min(1, {message: i18nValidation.enterText}),
})

const textImageSchema = baseHighlightSchema.extend({
  cta: buttonSchema,
  title: z.string().min(1, {message: i18nValidation.enterText}),
  description: z.string().min(1, {message: i18nValidation.enterText}),
})

export const highlightSchema = z.discriminatedUnion('visualization', [
  defaultHighlightSchema.extend({visualization: z.literal(BlockHighlightVisualizationEnum.Default)}),
  defaultHighlightSchema.extend({visualization: z.literal(BlockHighlightVisualizationEnum.ViceVersa)}),
  textImageSchema.extend({visualization: z.literal(BlockHighlightVisualizationEnum.TextImage)}),
  textImageSchema.extend({visualization: z.literal(BlockHighlightVisualizationEnum.TextImageViceVersa)}),
])
